import { c as _c } from "react/compiler-runtime";
import { DndContext, DragEndEvent, DragOverlay, DragStartEvent, MouseSensor, TouchSensor, UniqueIdentifier, closestCenter, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, arrayMove, rectSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DataFileInterface, FileSourceEnum } from '@systemeio/file-manager';
import React, { ReactNode, forwardRef, useState } from 'react';
import { ImageUploader } from 'shared/components/file-uploader/image-uploader';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useWindowSize from 'shared/hooks/use-window-size';
import { TrashIcon } from '@systemeio/ui/icons';
interface ProductMediaLibraryProps {
  images: DataFileInterface[];
  setImages: React.Dispatch<React.SetStateAction<DataFileInterface[]>>;
}
function ProductMediaLibrary(t0) {
  const $ = _c(21);
  const {
    images,
    setImages
  } = t0;
  const [showImageCount, setShowImageCount] = useState(4);
  const {
    width
  } = useWindowSize();
  const {
    t
  } = useLocoTranslation();
  const isMobile = width < 768;
  let t1;
  if ($[0] !== images) {
    t1 = images.map(_temp);
    $[0] = images;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sortableImages = t1;
  const [activeId, setActiveId] = useState(null);
  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor));
  let t2;
  if ($[2] !== setImages) {
    t2 = function onCoverUploadSuccess(dataFile) {
      setImages(prev => [...prev, dataFile]);
    };
    $[2] = setImages;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onCoverUploadSuccess = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function handleDragStart(event) {
      setActiveId(event.active.id);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleDragStart = t3;
  let t4;
  if ($[5] !== setImages) {
    t4 = function handleDragEnd(event_0) {
      const {
        active,
        over
      } = event_0;
      if (over && active.id !== over.id) {
        setImages(images_0 => {
          const oldIndex = images_0.findIndex(image_0 => image_0.path === String(active.id));
          const newIndex = images_0.findIndex(image_1 => image_1.path === String(over.id));
          return arrayMove(images_0, oldIndex, newIndex);
        });
      }
      setActiveId(null);
    };
    $[5] = setImages;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleDragEnd = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = function handleDragCancel() {
      setActiveId(null);
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleDragCancel = t5;
  let t6;
  if ($[8] !== setImages) {
    t6 = function handleDeleteImage(url) {
      setImages(prev_0 => prev_0.filter(image_2 => image_2.path !== url));
    };
    $[8] = setImages;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleDeleteImage = t6;
  let t7;
  if ($[10] !== activeId || $[11] !== handleDeleteImage || $[12] !== handleDragEnd || $[13] !== images || $[14] !== isMobile || $[15] !== onCoverUploadSuccess || $[16] !== sensors || $[17] !== showImageCount || $[18] !== sortableImages || $[19] !== t) {
    t7 = <>{!!images.length ? <DndContext sensors={sensors} collisionDetection={closestCenter} onDragStart={handleDragStart} onDragEnd={handleDragEnd} onDragCancel={handleDragCancel}><SortableContext items={sortableImages} strategy={rectSortingStrategy}><div className="grid grid-cols-[repeat(2,1fr)]  gap-2 p-[10px] md:grid-cols-[repeat(4,1fr)]">{isMobile ? images.slice(0, showImageCount).map((image_3, index) => <SortablePhoto key={image_3.path} url={image_3.path} index={index} deleteImage={handleDeleteImage} />) : images.map((image_4, index_0) => <SortablePhoto key={image_4.path} url={image_4.path} index={index_0} deleteImage={handleDeleteImage} />)}<ImageUploader imageCropperModalProps={{
              imageCropperProps: {
                aspectRatio: 1
              }
            }} dropZoneClassName="mt-0 p-0 w-full h-full min-h-[80px] lg:min-h-[120px]" onSelect={onCoverUploadSuccess} source={FileSourceEnum.Product} /></div></SortableContext>{showImageCount < images.length && <div className="flex items-center justify-center" onClick={() => setShowImageCount(_temp2)}>{t("dashboard.products.media.load_more_label")}</div>}<DragOverlay adjustScale={true}>{activeId ? <div className="relative" style={getImageContainerStyles(images.findIndex(image_5 => image_5.path === String(activeId)))}><TrashIcon className="fill-brand-primarygray hover:fill-danger absolute right-2 top-2 cursor-pointer" width="14px" onClick={() => handleDeleteImage(activeId)} /><Photo url={activeId} index={images.findIndex(image_6 => image_6.path === String(activeId))} /></div> : null}</DragOverlay></DndContext> : <ImageUploader imageCropperModalProps={{
        imageCropperProps: {
          aspectRatio: 1
        }
      }} dropZoneClassName="mt-0 p-0 w-full h-full min-h-[80px] lg:min-h-[120px]" onSelect={onCoverUploadSuccess} source={FileSourceEnum.Product} />}</>;
    $[10] = activeId;
    $[11] = handleDeleteImage;
    $[12] = handleDragEnd;
    $[13] = images;
    $[14] = isMobile;
    $[15] = onCoverUploadSuccess;
    $[16] = sensors;
    $[17] = showImageCount;
    $[18] = sortableImages;
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
function _temp2(prev_1) {
  return prev_1 + 4;
}
function _temp(image) {
  return {
    ...image,
    id: image.path
  };
}
interface PhotoProps {
  children?: ReactNode;
  url: UniqueIdentifier;
  index: number;
  style?: Record<string, any>;
  isDragging?: boolean;
}
type Ref = HTMLDivElement;
const Photo = forwardRef<Ref, PhotoProps>((t0, ref) => {
  const $ = _c(16);
  let index;
  let isDragging;
  let props;
  let style;
  let url;
  if ($[0] !== t0) {
    ({
      url,
      index,
      style,
      isDragging,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = index;
    $[2] = isDragging;
    $[3] = props;
    $[4] = style;
    $[5] = url;
  } else {
    index = $[1];
    isDragging = $[2];
    props = $[3];
    style = $[4];
    url = $[5];
  }
  const t1 = index === 0 ? "span 2" : undefined;
  const t2 = index === 0 ? "span 2" : undefined;
  const t3 = isDragging ? "none" : `url("${url}")`;
  const t4 = isDragging ? "gray" : "rgb(var(--background-secondary))";
  let t5;
  if ($[6] !== style || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = {
      gridRowStart: t1,
      gridColumnStart: t2,
      backgroundImage: t3,
      backgroundColor: t4,
      ...style
    };
    $[6] = style;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const inlineStyles = t5;
  let t6;
  if ($[12] !== inlineStyles || $[13] !== props || $[14] !== ref) {
    t6 = <div ref={ref} className="border-[rgb(var(--text-secondary-400))] origin-[0px_0px] rounded-sm border-2 bg-contain bg-center bg-no-repeat pb-[100%]" style={inlineStyles} {...props} />;
    $[12] = inlineStyles;
    $[13] = props;
    $[14] = ref;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
});
Photo.displayName = 'Photo';
const getImageContainerStyles = (index?: UniqueIdentifier) => {
  return {
    gridRowStart: index === 0 ? 'span 2' : undefined,
    gridColumnStart: index === 0 ? 'span 2' : undefined
  };
};
interface SortablePhotoProps {
  url: UniqueIdentifier;
  index: number;
  deleteImage: (value: UniqueIdentifier) => void;
}
const SortablePhoto = t0 => {
  const $ = _c(24);
  const {
    url,
    index,
    deleteImage
  } = t0;
  let t1;
  if ($[0] !== url) {
    t1 = {
      id: url
    };
    $[0] = url;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sortable = useSortable(t1);
  const {
    attributes,
    listeners,
    isDragging,
    setNodeRef,
    transform,
    transition
  } = sortable;
  let t2;
  if ($[2] !== transform) {
    t2 = CSS.Transform.toString(transform);
    $[2] = transform;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== transition) {
    t3 = {
      transform: t2,
      transition
    };
    $[4] = t2;
    $[5] = transition;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const style = t3;
  let t4;
  if ($[7] !== index) {
    t4 = getImageContainerStyles(index);
    $[7] = index;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== deleteImage || $[10] !== url) {
    t5 = <TrashIcon className="fill-brand-primarygray hover:fill-danger absolute right-2 top-2 cursor-pointer" width="14px" onClick={() => deleteImage(url)} />;
    $[9] = deleteImage;
    $[10] = url;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== attributes || $[13] !== index || $[14] !== isDragging || $[15] !== listeners || $[16] !== setNodeRef || $[17] !== style || $[18] !== url) {
    t6 = <Photo ref={setNodeRef} style={style} url={url} index={index} isDragging={isDragging} {...attributes} {...listeners} />;
    $[12] = attributes;
    $[13] = index;
    $[14] = isDragging;
    $[15] = listeners;
    $[16] = setNodeRef;
    $[17] = style;
    $[18] = url;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <div className="relative" style={t4}>{t5}{t6}</div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export default ProductMediaLibrary;